<template>
  <div class="profile">
    <nav-bar/>
    <div class="page-header">
      <div class="grid-container">
        <h1>Profile</h1>
        <p>
          Lihat profil serta segala pencapaianmu.<br>
        </p>
      </div>
    </div>
    <div class="grid-container">
      <div class="profile-content">
        <div class="heading">
          <h1>Statistik</h1>
          <p>Lihat statistik profilmu secara umum</p>
        </div>
        <div class="user-bar-wrapper">
          <user-bar/>
        </div>
        <div class="flex-responsive mt-2 space-evenly">
          <div class="stats-item">
            <b>Statistik persoalan dikerjakan</b>
            <hr>
            <div class="flex space-between">
              <span>Lesson</span>
              <b>{{$store.getters['userStore/getLessonFinishedCount']}}</b>
            </div>
            <div class="flex space-between">
              <span>Single Task</span>
              <b>{{$store.getters['userStore/getSingleFinishedCount']}}</b>
            </div>
            <div class="flex space-between">
              <span>Quest</span>
              <b>{{$store.getters['userStore/getQuestFinishedCount']}}</b>
            </div>
          </div>
          <div class="stats-item">
            <b>Statistik akun</b>
            <hr>
            <div class="flex space-between">
              <span>Jumlah <small>XP</small></span>
              <span><b>{{userDataStore.expTotal}}</b><small>XP</small></span>
            </div>
            <div class="flex space-between">
              <span>Jumlah <i>badge</i></span>
              <b>{{$store.getters['userStore/getBadgesCount']}}/{{$store.getters['userStore/getAllBadgesCount']}}</b>
            </div>
          </div>
          <div class="stats-item">
            <b>Statistik skor</b>
            <hr>
            <div class="flex space-between">
              <span>Jumlah skor</span>
              <b>{{$store.getters['userStore/getScores'].toFixed(2)}}%</b>
            </div>
            <div class="flex space-between">
              <span>Rata-rata skor</span>
              <b>{{$store.getters['userStore/getAverageScores'].toFixed(2)}}%</b>
            </div>
            <div class="flex space-evenly mt-1">
              <div class="text-center">
                <div class="silver"></div>
                <b>{{$store.getters['userStore/getSilverScoresCount']}}</b>
              </div>
              <div class="text-center">
                <div class="gold"></div>
                <b>{{$store.getters['userStore/getGoldScoresCount']}}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="profile-content">
        <h1>Badges</h1>
        <p>Lihat <i>badge</i> yang telah kamu dapatkan</p>
        <div class="all-badges">
          <div class="badge" v-for="item in userDataStore.badges" :key="item.id">
            <div class="image-wrapper" >
              <img class="image-fit" :class="{'inactive': !item.acquired}" :src="item.image"/>
              <div class="flyout hover-desc">
                <b>{{item.name}}</b>
                <p>
                  <span v-if="!item.acquired">
                    <i class="fas fa-lock"></i> <small>Terkunci</small><br>
                  </span>
                  <small v-else>Diraih pada {{prettifyDate(item.acquiredDate)}}</small>
                </p>
                <hr>
                <div>
                  <p>{{item.description}}</p>
                  <small v-if="!item.acquired"><i class="fas fa-coins"></i> <b>+{{item.reward}}</b></small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="profile-content">
        <h1>Performance</h1>
        <p>Lihat kinerjamu berdasarkan XP dan <i>performance point</i> yang didapat<br><i>Performance point</i> diberi bobot terurut dari XP yang paling tinggi</p>
        <div class="performance-content" v-if="userDataStore.finishedTask.length !== 0">
          <div class="performance-item align-items-center" v-for="(item, index) in userDataStore.finishedTask" :key="index">
            <div class="flex-column">
              <b>{{item.name}}</b>
              <small>{{mapType(item.type)}}</small>
            </div>
            <div class="flex align-items-center">
              <div>
                <strong>{{item.score.toFixed(2)}}% </strong>
                <i class="fas fa-arrow-right"></i>
              </div>
              <div class="flex-column text-end ml-2">
                <span><b>{{item.expGained}}</b>XP</span>
                <small>ppt: <strong>{{Math.floor(item.expGained*Math.pow(0.95, index))}}</strong></small>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center mt-2 performance-item">
          Belum ada persoalan yang kamu kerjakan :(
        </div>
      </div>
    </div>
    <button @click="$store.commit('userStore/resetProgress')">Reset Progress</button>
    <footer-bar/>
  </div>
</template>

<script>
  import NavBar from '@/components/NavBar'
  import UserBar from '@/components/UserBar/'
  import FooterBar from '@/components/FooterBar'
  import {prettifyDate} from '@/utilities/date'

  export default {
    name: 'profile',
    components: {
      NavBar,
      UserBar,
      FooterBar
    },
    data() {
      return {

      }
    },
    computed: {
      userDataStore() {
        return this.$store.state.userStore
      },
    },
    methods: {
      prettifyDate,
      mapType(type) {
        if (type === 'lesson') return 'Lesson'
        else if (type === 'single') return 'Single Task'
        else return 'Quest'
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/styles/colors";
  @import "src/styles/responsive";

  .user-bar-wrapper {
    width: 100%;
    max-width: 300px;
    margin: auto;
    border-radius: 10px;
    box-shadow: 0 5px 5px rgba(black, 0.2);
  }

  .stats-item {
    width: 100%;
    max-width: 300px;
    margin-left: 1rem;
    margin-right: 1rem;
    box-sizing: border-box;

    @include mobile {
      margin-bottom: 2rem;
    }
  }

  .silver, .gold {
    height: 15px;
    width: 30px;
    border-radius: 5px;
    box-shadow: 0 3px 5px rgba(black, 0.2);
  }

  .silver {
    background: linear-gradient(to bottom right, rgba(195,214,223,1) 0%, rgba(176,194,207,1) 36%, rgba(146,171,185,1) 50%, rgba(165,209,238,1) 100%);
  }

  .gold {
    background: linear-gradient(to bottom right, rgba(213,173,109,1) 0%, rgba(213,173,109,1) 26%, rgba(226,186,120,1) 35%, rgba(163,126,67,1) 45%, rgba(145,112,59,1) 61%, rgba(213,173,109,1) 100%);
  }

  .profile-content {
    margin-bottom: 2rem;

    .heading {
      margin-bottom: 1rem;
    }

    h1 {
      color: $blue;
      background: linear-gradient(to bottom right, #0C728B, $blue);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .all-badges {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    margin-top: 2rem;
  }

  .badge {
    flex-basis: 20%;
    margin-bottom: 2rem;
    display: flex;
    position: relative;

    .image-wrapper {
      margin: auto;
      width: 128px;
      height: 128px;
      position: relative;
      display: flex;
      justify-content: center;
    }

    .inactive {
      filter: blur(3px) grayscale(1) brightness(50%);
      opacity: 0.25;
    }

    .image-fit:hover + .hover-desc {
      opacity: 1;
      transform: scale(1, 1);
    }

    .hover-desc {
      text-align: center;
      position: absolute;
      z-index: 20;
      width: calc(128px + 2rem);
      padding: 1rem;
      left: -2rem;
      top: 128px;
      opacity: 0;
      transform: scale(0.8, 0.8);
      pointer-events: none;
      transition: all 0.1s;
      transform-origin: 50% 0;
    }

    p {
      font-size: 0.9rem;
    }
  }

  .performance-content {
    margin-top: 1rem;
  }

  .performance-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    padding: 0.5rem;
    color: $gray;
    background-color: rgba(black, 0.025);
    border-radius: 10px;
    transition: all 0.1s;

    &:hover {
      color: black;
      background-color: rgba(black, 0.1);
    }

    b {
      font-size: 1.2rem;
    }
  }

  .dark-mode {
    .performance-item {
      color: $demi-gray;
      background-color: rgba(black, 0.1);

      &:hover {
        color: white;
        background-color: rgba(black, 0.2);
      }
    }
    .profile-content h1 {
      filter: brightness(2) contrast(0.75);
    }
  }
</style>
